import type React from 'react';
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next';
import { NavMenu } from "@shopify/app-bridge-react"
const ShopifyMenu: React.FC = () => {
    const { t } = useTranslation();
    return (
      <NavMenu>
        <Link to="/home" rel="home">
          Home
        </Link>
        <Link to="/widget-setting">{t('navigation.chatWidget')}</Link>
        <Link to="/faq">{t('navigation.faq')}</Link>
        <Link to="/setting">{t('navigation.settings')}</Link>
        {/* <Link to="/auth">test</Link> */}
      </NavMenu>
    )
}
export default ShopifyMenu;